'use client'
import styles from './AccordionBlock.module.scss'
import Accordion from '@/src/components/common/Accordion'
import { Block_Accordion } from '@/src/generated/graphql'
import { classNames } from '@/src/helpers/component'
import DirectusImage from '@/src/components/common/DirectusImage'
import WysiwygContent from '@/src/components/common/WysiwygContent'

export default function AccordionBlockClient(block: Block_Accordion) {
  if (!block.items?.length) return null

  return (
    <Accordion
      accordionControls
      className={classNames('--block-accordion', styles.container)}
      items={block.items.map((junction, idx) => {
        const _ = junction?.block_simple_content_id
        return {
          id: _?.anchor_id ?? undefined,
          chevronCollapsed: 'down',
          chevronExpanded: 'up',
          header: (
            <div key={idx} className={styles.header}>
              {block.show_icons && (
                <DirectusImage directusFile={_?.image} className={styles.headerIcon} />
              )}
              <h4>{_?.heading}</h4>
            </div>
          ),
          content: <WysiwygContent key={idx} content={_?.content ?? ''} />,
        }
      })}
    />
  )
}
